<template>
    <div :class="['billing_card_wrapper billing_card', { active, selected }]">
        <div v-if="isGrowth" class="billing_card__popular">Most Popular</div>
        <div class="billing_card__title">{{ title }}</div>

        <div class="billing_card__price">
            {{ price }} <span>{{ period }}</span>
        </div>

        <div class="billing_card__btn">
            <button :disabled="disabled" :class="['card_btn', { selected }]" type="submit" @click="$emit('click')">
                {{ selected ? 'Your plan' : 'Start plan' }}
            </button>
        </div>

        <div class="billing_card__includes card_includes">
            <span class="card_includes__title">Includes: </span>
            <PlanItemInclude :selected="selected" :text="chatBotsCount" />
            <PlanItemInclude :selected="selected" :text="chatMessagesCount" />
            <PlanItemInclude :selected="selected" :text="chatLinksCount" />
            <PlanItemInclude :selected="selected" :text="chatFilesCount" />
            <PlanItemInclude :selected="selected" :text="chatFileSize" />
        </div>

        <div v-if="selected" class="billing_card__link">
            <a @click="copyEmail">To manage plan, please contact support</a>
        </div>
    </div>
</template>

<script>
import PlanItemInclude from "../../components/billing/PlanItemInclude.vue";

export default {
    name: 'billing-price',
    components: { PlanItemInclude },
    props: {
        type: {
            type: String,
            required: true,
            validator: value => {
                const acceptedValues = ['starter', 'growth', 'scale'];
                return acceptedValues.indexOf(value.toLowerCase()) !== -1;
            }
        },
        active: {
            type: Boolean,
            default: false
        },
        selected: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        popular: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            required: true
        },
        price: {
            type: String,
            required: true
        },
        period: {
            type: String,
            required: false,
            default: '/mo'
        },
    },
    computed: {
        isScale() {
            return this.type.toLowerCase() === 'scale'
        },
        isGrowth() {
            return this.type.toLowerCase() === 'growth'
        },
        chatBotsCount() {
            return (this.isScale ? 5 : this.isGrowth ? 2 : 1) + ' chatbot';
        },
        chatMessagesCount() {
            return 'Upto ' + (this.isScale ? '40k' : this.isGrowth ? '10k' : '4k') + ' messages per month';
        },
        chatLinksCount() {
            return 'Upto ' + (this.isScale ? '10,000' : this.isGrowth ? '2,000' : '200') + ' training web pages';
        },
        chatFilesCount() {
            return (this.isScale ? 500 : this.isGrowth ? 100 : 10) + ' file uploads';
        },
        chatFileSize() {
            return 'Upto ' + (this.isScale ? 10 : this.isGrowth ? 10 : 10) + ' per file';
        },
    },
    methods: {
        async copyEmail() {
            try {
                await navigator.clipboard.writeText("support@replymonster.ai");
                this.$toast.success("Email copied");
            } catch (e) {
                console.log(error);
                this.$toast.error("Copy email error");
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.billing_card_wrapper {
    position: relative;
    padding: 32px 32px 0;
    width: 344px;
    height: 552px;
    border: 1px solid #BBBBBB;
    border-radius: 16px;
    color: #212b36;

    @media screen and (max-width: 520px) {
        width: 100%;
        height: auto;
    }
}

.billing_card_wrapper.selected {
    border: 1px solid #27AE60;
}

.billing_card_wrapper.active {
    border: 1px solid #3056D3;
}

.billing_card {
    &__popular {
        position: absolute;
        top: 18px;
        right: 16px;
        border-radius: 8px;
        padding: 4px 8px;
        font-style: 12px;
        line-height: 16px;
        font-weight: 600;
        background-color: #3056D3;
        color: #fff;

        @media screen and (max-width: 520px) {
            top: 8px;
        }
    }

    &__title {
        padding-bottom: 24px;
        font-size: 20px;
        line-height: 28px;
        letter-spacing: -0.5px;
        font-weight: 600;
    }

    &__price {
        font-size: 36px;
        line-height: 40px;
        letter-spacing: -0.9px;
        font-weight: 700;

        span {
            color: #667085;
            font-size: 20px;
            line-height: 28px;
            font-weight: 500;
            letter-spacing: -0.5px;
        }
    }

    &__btn .card_btn {
        margin: 24px 0;
        width: 100%;
        font-family: inherit;
        font-size: 14px;
        line-height: 20px;
        font-weight: 600;
        color: #3056D3;
        outline: none;
        background: transparent;
        border: 1px solid #3056D3;
        border-radius: 8px;
        padding: 10px;
        cursor: pointer;
        transition: all 150ms linear;

        &:disabled {
            pointer-events: none;
            cursor: default;
            opacity: 0.6;
        }

        &:hover,
        &:focus-visible {
            color: #fff;
            background-color: #3056D3;
        }
    }

    &__btn .card_btn.selected {
        color: #27AE60;
        background-color: #E4FFF0;
        border: 1px solid #27AE60;

        &:hover,
        &:focus-visible {
            color: #fff;
            background-color: #27AE60;
        }
    }

    &__includes {
        margin-bottom: 40px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        border-top: 1px solid #BBBBBB;
        padding: 24px 0 0 0;

        .card_includes {
            &__title {
                text-transform: uppercase;
                font-size: 12px;
                line-height: 16px;
                letter-spacing: 0.3px;
                font-weight: 600;
                color: #BBBBBB;
            }

        }
    }

    &__link {
        font-size: 14px;
        line-height: 24px;
        color: #98A1B2;
        text-decoration: underline;
        cursor: pointer;
    }
}
</style>